import React, {Component, useEffect, useState} from 'react';
import {EditorState} from 'draft-js';
import {Editor} from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {stateToHTML} from 'draft-js-export-html';
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {usePoliceMode} from "../policeMode/hook/usePoliceMode";

const WiswigEditor = ({onChange, reset, placeholder, detailIsError}) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const {mode} = useDarkMode();
  const {police} = usePoliceMode();

  useEffect(() => {
    const content = stateToHTML(editorState.getCurrentContent());
    if (content !== "<p><br></p>") {
      onChange(content);
    }

  }, [editorState]);

  useEffect(() => {
    console.log(reset);
    if (reset) {
      setEditorState(EditorState.createEmpty());
    }
  }, [reset])

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState)
  }

  return <Editor
      wrapperClassName={mode.darkMode ? "wrapper-class-dark" : ""}
      editorClassName={
        mode.darkMode
            ? police.normalMode
                ? detailIsError
                    ? "editor-class-dark error-class-wysiwyg"
                    : "editor-class-dark"
                : detailIsError
                    ? "editor-class-dark-dyslexie error-class-wysiwyg"
                    : "editor-class-dark-dyslexie"
            : police.normalMode
                ? detailIsError
                    ? "error-class-wysiwyg"
                    : ""
                : detailIsError
                    ? "editor-class-dyslexie error-class-wysiwyg"
                    : "editor-class-dyslexie"
      }
      toolbarClassName={mode.darkMode ? "toolbar-class-dark" : ""}
      placeholder={placeholder}
      editorState={editorState}
      onEditorStateChange={onEditorStateChange}
  />
}

export default WiswigEditor;
